import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useTrack } from '@hackler/react-sdk';
import { setEventProperties } from "../redux/amplitude";
import { useLastLocation } from 'react-router-last-location';
import { useParams } from 'react-router-dom';

import AMPLITUDE_DATA from "../constant/AMPLITUDE_DATA";
import { TYPE } from "../constant";
import _ from "lodash";
import HACKLE_DATA from "../constant/HACKLE_DATA";

export default function useAmplitude() {
  const dispatch = useDispatch();
  const params = useParams();
  const track = useTrack();
  const lastLocation = useLastLocation();

  const setAmplitudeLog  = useCallback(async ({eventCategory, eventName, isHackleSend = false}) => {
    const channelCode = localStorage.getItem('channel.code');
    if (!channelCode || channelCode !== 'GLOBAL01' || !eventName) return;

    if (typeof eventName === 'string' && eventCategory) {
      var data = JSON.parse(JSON.stringify(AMPLITUDE_DATA));
      var result = await getScreen(data[eventCategory][eventName]);

      dispatch(setEventProperties(result));
      if (isHackleSend) track(getHackleEvntInfo(eventName));

    } else if (typeof eventName === 'object') {
      if (!eventName.name || !eventName.event) return;

      const { name, event } = await getScreen(eventName);
      dispatch(setEventProperties({ name, event }));
      if (isHackleSend) track(getHackleEvntInfo(eventName.name));
    } 
    
  }, []);

  const getScreen = useCallback(event => {
    
    if (event) {
      const isScreen = Object.keys(event.event).indexOf('소스화면') > -1;
      const learningCode = Object.keys(event.event).indexOf('학습유형') > -1;
      if (isScreen && !event.event["소스화면"]) {
        event.event = {
          ...event.event,
          "소스화면": lastLocation?.pathname,
        }
      }

      if (learningCode) {
        let code = params?.learningType;
        if (!code) {
          code = event.event["학습유형"];
          if (!code) return event;
        }

        event.event = {
          ...event.event,
          "학습유형": code === TYPE.LEARNING.COURSE ? '코스학습' : '주제학습'
        };
      }
    }
    return event;
  });

  const setHackleLog = useCallback(({ eventName }) => {
    track(getHackleEvntInfo(eventName))
  }, [])

  /* get Hackle 이벤트 정보 */
  const getHackleEvntInfo = useCallback((eventName) => {
    const hacleEventData = { ...HACKLE_DATA.EVENT[eventName] }; 
    
    // 정의된 데이터 없을경우
    if(_.isEmpty(hacleEventData)) return;

    const { key, value, properties } = hacleEventData;
    let event = { key };
    
    // 정의된 value, properties 가 있는경우
    if(!_.isNull(value)) event['value'] = value;
    if(!_.isEmpty(properties)) event['properties'] = properties;
    
    return event;
  }); 

  return {
    setAmplitudeLog,
    setHackleLog,
    getHackleEvntInfo
  }
}